module.exports = __webpack_public_path__ + "nc_static/media/upload-csr.663e6e41.svg";